// extracted by mini-css-extract-plugin
export var backToTopBtn = "back-to-top-module--backToTopBtn--c1c00";